import { combineReducers } from "redux";
import productDetailsReducer from "./productDetails";
import userReducer from "./user";
import loaderReducer from "./loaders";
import featuredProductsReducer from "./featuredProducts";
import filteredProductsReducer from "./filteredProducts";
import categoryReducer from "./category";
import subCategoryReducer from "./subcategory";

export default combineReducers({
  filteredProducts: filteredProductsReducer,
  productDetails: productDetailsReducer,
  featuredProducts: featuredProductsReducer,
  userDetails: userReducer,
  loaderDetail: loaderReducer,
  categoryDetail: categoryReducer,
  subCategoryDetail: subCategoryReducer,
});

